import { cookieStorage } from '@nubank/www-latam-commons/utils/storage';

export const getClientId = () => {
  const GA_CLIENT_ID_COOKIE = '_ga';

  const gaClientId = cookieStorage.getString(GA_CLIENT_ID_COOKIE);

  return gaClientId && gaClientId.replace(/GA[0-9]+.[0-9]+./, '');
};
